export enum SiteHeaderType {
    LocalHeader,
    WWWSiteHeader
  }